/**
 * mSTEM mock project detail metadata (PRJ-02 S-2 "Xem thông tin các dự án đã
 * tạo" — the ℹ row action on the Open Project list).
 *
 * WHY A SEPARATE FILE: src/lib/mstem-mock/projects.js seeds
 * `state.scratchGui.myProjects.list` and is asserted field-by-field by
 * test/unit/mstem/smarthome-scenarios.test.js. Detail-only fields (block
 * counts, sprites, hardware used…) are never needed to render the LIST, so
 * they live here and are merged in only when the detail modal opens. That
 * keeps the list payload small and the seed test untouched.
 *
 * MOCK-ONLY: no project is ever parsed to derive these numbers — the BE team
 * replaces this with the real /projects/{id} response. Kept to exactly the
 * fields the (deliberately compact) detail modal renders — block-group and
 * peripheral chip lists were dropped along with their panels.
 *
 * Keyed by the same project ids as MOCK_PROJECTS. A project with no entry here
 * degrades to `{}` (getProjectDetail), and the modal renders '—' per field, so
 * a user-created project never breaks the surface.
 */

const PROJECT_DETAILS = {
    'mbf-robot-line-01': {
        author: 'Nguyễn Văn An',
        className: 'Lớp 8A2',
        blockCount: 42,
        spriteCount: 2,
        backdropCount: 1,
        variableCount: 3,
        sizeKB: 128,
        deviceModel: 'MBF Robot v2',
        visibility: 'private',
        openCount: 12,
        lastOpenedAt: '2026-05-25T14:30:00.000Z'
    },
    'mbf-led-alert-02': {
        author: 'Nguyễn Văn An',
        className: 'Lớp 8A2',
        blockCount: 28,
        spriteCount: 1,
        backdropCount: 1,
        variableCount: 2,
        sizeKB: 96,
        deviceModel: 'MBF Robot v2',
        visibility: 'private',
        openCount: 7,
        lastOpenedAt: '2026-05-26T10:00:00.000Z'
    },
    'mbf-rfid-door-03': {
        author: 'Trần Thị Bình',
        className: 'Lớp 9A1',
        blockCount: 35,
        spriteCount: 1,
        backdropCount: 2,
        variableCount: 4,
        sizeKB: 112,
        deviceModel: 'MBF Home Starter Kit',
        visibility: 'shared',
        openCount: 21,
        lastOpenedAt: '2026-05-28T16:45:00.000Z'
    },
    'mbf-classroom-sensor-04': {
        author: 'Trần Thị Bình',
        className: 'Lớp 9A1',
        blockCount: 54,
        spriteCount: 3,
        backdropCount: 2,
        variableCount: 6,
        sizeKB: 184,
        deviceModel: 'MBF Home Pro Kit',
        visibility: 'shared',
        openCount: 33,
        lastOpenedAt: '2026-06-01T09:20:00.000Z'
    },
    'mbf-cat-animation-05': {
        author: 'Lê Minh Cường',
        className: 'Lớp 7A3',
        blockCount: 18,
        spriteCount: 2,
        backdropCount: 3,
        variableCount: 1,
        sizeKB: 64,
        deviceModel: null,
        visibility: 'private',
        openCount: 4,
        lastOpenedAt: '2026-06-05T08:00:00.000Z'
    },
    'mbf-smarthome-relay-06': {
        author: 'Phạm Thu Hà',
        className: 'Lớp 8A1',
        blockCount: 16,
        spriteCount: 1,
        backdropCount: 1,
        variableCount: 1,
        sizeKB: 58,
        deviceModel: 'MBF Home Starter Kit',
        visibility: 'private',
        openCount: 9,
        lastOpenedAt: '2026-06-10T10:00:00.000Z'
    },
    'mbf-smarthome-tempalarm-07': {
        author: 'Phạm Thu Hà',
        className: 'Lớp 8A1',
        blockCount: 24,
        spriteCount: 1,
        backdropCount: 1,
        variableCount: 3,
        sizeKB: 74,
        deviceModel: 'MBF Home Starter Kit',
        visibility: 'shared',
        openCount: 15,
        lastOpenedAt: '2026-06-11T14:00:00.000Z'
    },
    'mbf-smarthome-rfiddoor-08': {
        author: 'Phạm Thu Hà',
        className: 'Lớp 8A1',
        blockCount: 31,
        spriteCount: 1,
        backdropCount: 1,
        variableCount: 4,
        sizeKB: 102,
        deviceModel: 'MBF Home Pro Kit',
        visibility: 'shared',
        openCount: 18,
        lastOpenedAt: '2026-06-12T16:30:00.000Z'
    }
};

/**
 * Detail metadata for a project id. Unknown ids (user-created projects) return
 * an empty object rather than undefined so callers can spread it safely.
 * @param {string} id - the project id.
 * @returns {object} the detail record, or {} when there is none.
 */
const getProjectDetail = id => PROJECT_DETAILS[id] || {};

export {PROJECT_DETAILS, getProjectDetail};
export default PROJECT_DETAILS;
